import styled from "styled-components";

export const ImportWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: #f4f4f4;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;          /* no gap above tabs */
  overflow: hidden;    /* body scroll lives in PageBody */
`;

export const PageBody = styled.div`
  flex: 1;
  overflow: auto;
  padding: 30px;

  @media (max-width: 768px) { padding: 18px; }
  @media (max-width: 480px) { padding: 12px; }
`;

export const TabsBar = styled.div`
  position: sticky;
  top: var(--topbar-height, 56px); /* sits directly under TopBar */
  z-index: 3;
  background: #f4f4f4;
  border-bottom: 1px solid #e8eef5;
`;

export const Card = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  padding: 30px;
  margin: 30px 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  }
`;

export const FileInput = styled.input`
  margin: 15px 15px 0 0; /* top right bottom left */
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  width: auto;
  max-width: 400px;
`;



export const ScrollableTableWrapper = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-top: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #fdfdfd;
  }

  &:hover {
    background-color: #f4f6f8;
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  border-bottom: 1px solid #eee;
`;

export const TableHeader = styled.th`
  padding: 12px;
  background-color: #fafafa;
  border-bottom: 2px solid #ddd;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Message = styled.div`
  color: ${({ $isError }) => ($isError ? "#e63946" : "#2a9d8f")};
  font-size: 16px;
  margin-top: 15px;
  background-color: ${({ $isError }) => ($isError ? "#fdecea" : "#e6f4f1")};
  border-left: 4px solid ${({ $isError }) => ($isError ? "#e63946" : "#2a9d8f")};
  padding: 10px 15px;
  border-radius: 6px;
`;

export const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 25px;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background-color: #0056b3;
    box-shadow: 0 4px 14px rgba(0, 123, 255, 0.4);
  }

  &:disabled {
    background-color: #aaa;
    cursor: not-allowed;
  }
`;

export const TabButtons = styled.div`
  display: flex;
  flex-wrap: wrap;          /* allow 2+ lines, no scroll */
  gap: 10px;
  row-gap: 10px;
  padding: 10px 12px;
`;

export const TabButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 999px;     /* pill */
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;

  /* base (inactive) */
  color: #1f2937;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
  transition: background .18s ease, color .18s ease, border-color .18s ease,
              box-shadow .18s ease, transform .06s ease;

  svg { width: 18px; height: 18px; color: inherit; }

  &:hover {
    background: #f1f5f9;
    border-color: #dbe2ea;
    transform: translateY(-1px);
  }

  /* ACTIVE state */
  ${({ $active }) =>
    $active &&
    `
      color: #ffffff;
      background: #0b74e5;
      border-color: #0b74e5;
      box-shadow: 0 2px 8px rgba(11,116,229,.25);
    `}

  ${({ $active }) =>
    $active &&
    `
      &:hover {
        background: #0a67cc;
        border-color: #0a67cc;
      }
    `}

  @media (max-width: 768px) { padding: 9px 12px; font-size: 14px; }
  @media (max-width: 560px) { padding: 8px 10px; font-size: 13.5px; gap: 6px; }
  @media (max-width: 420px) {
    padding: 7px 9px; font-size: 13px;
    span { overflow: hidden; text-overflow: ellipsis; max-width: 160px; }
  }
`;

export const ProgressBarWrapper = styled.div`
  text-align: center;
  margin: 25px 0;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 12px;
  overflow: hidden;

  & > div {
    height: 100%;
    background-color: #007bff;
    transition: width 0.4s ease;
  }
`;

export const SummarySection = styled.div`
  margin: 25px 0;
  padding: 20px;
  border: 1px solid #eee;
  background-color: #fafafa;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);

  p {
    margin: 8px 0;
  }

  ul {
    list-style-type: disc;
    padding-left: 25px;
  }

  li {
    margin-bottom: 8px;
  }
`;
